import * as d3 from 'd3-selection'
import rect from './lib/rect.js'
import title from './lib/title.js'
import gauge from './lib/gauge.js'
import fields from './lib/fields.js'
import header from './lib/header.js'

let count = 0

// Mix transitions into d3.selection's prototype
import 'd3-transition'

export default function (container, data) {
  var dim = {
      padding: {
        left: 8,
        right: 8
      },
      header: {
        height: 15
      },
      viewbox: {
        width: 100,
        height: 0 // starts at 0 and is built up based on its contents
      }
    }
    , svg = d3.select(container)
              .selectAll('svg')
              .data([data])
    , enter = svg.enter()
                 .append('svg')
                   .attr('class', 'radial-gauge')
                   .attr('id', function () {
                     return 'gauge-' + (++count)
                   })
    , _svg = enter.merge(svg)

  enter.append('defs')

  dim.width = dim.viewbox.width - dim.padding.left - dim.padding.right

  let id = _svg.attr('id')
  _svg.call(header(id, dim))
      .call(gauge(id, dim))
      .call(title(dim, 'title'))
      .call(title(dim, 'subtitle'))
      .call(fields(dim))
      .call(rect(dim))
      .attr('viewBox', '0 0 ' + dim.viewbox.width + ' ' + dim.viewbox.height)

  return _svg
}
